import { BookOpenCheck, CheckCircle2, CircleAlert, LockKeyhole, UserRound } from "lucide-react";

export const IntegrationStatus = ({ item, compact = false, testIdPrefix = "integration" }) => {
  const ready = item.configured;
  const firmSetup = item.availability === "Firm setup needed";
  const StatusIcon = ready ? CheckCircle2 : firmSetup ? CircleAlert : BookOpenCheck;
  const statusTone = ready
    ? "bg-[#DCFCE7] text-[#166534]"
    : firmSetup
      ? "bg-[#FFF4D6] text-[#775414]"
      : "bg-[#EAF4FB] text-[#1F6FA8]";
  const AccessIcon = item.admin_only ? LockKeyhole : UserRound;
  return (
    <div className={`flex ${compact ? "flex-row" : "flex-wrap"} items-center gap-1.5`}>
      <span className={`inline-flex items-center gap-1 rounded px-2 py-1 font-mono text-[10px] ${statusTone}`} data-testid={`${testIdPrefix}-status-${item.key}`}>
        <StatusIcon className="h-3 w-3" />{item.availability}
      </span>
      {!compact && (
        <span className={`inline-flex items-center gap-1 rounded px-2 py-1 text-[10px] font-semibold ${item.admin_only ? "bg-[#F1F5F9] text-[#475569]" : "bg-[#EEF2FF] text-[#414A9A]"}`} data-testid={`${testIdPrefix}-access-${item.key}`}>
          <AccessIcon className="h-3 w-3" />{item.access_label}
        </span>
      )}
    </div>
  );
};
